import type { CellRange } from "../shared/table-tools";

export type TableInteraction = {
  anchor: { row: number; column: number };
  focus: { row: number; column: number };
  search: string;
};

const states = new Map<string, TableInteraction>();
const listeners = new Map<string, Set<() => void>>();
const initial = (): TableInteraction => ({
  anchor: { row: 0, column: 0 },
  focus: { row: 0, column: 0 },
  search: "",
});

export function getTableInteraction(id: string) {
  let value = states.get(id);
  if (!value) {
    value = initial();
    states.set(id, value);
  }
  return value;
}

export function subscribeTableInteraction(id: string, fn: () => void) {
  let set = listeners.get(id);
  if (!set) listeners.set(id, (set = new Set()));
  set.add(fn);
  return () => {
    set?.delete(fn);
    if (!set?.size) listeners.delete(id);
  };
}

function update(id: string, patch: Partial<TableInteraction>) {
  states.set(id, { ...getTableInteraction(id), ...patch });
  listeners.get(id)?.forEach((fn) => fn());
}

export function selectTableCell(
  id: string,
  row: number,
  column: number,
  extend = false,
) {
  const point = { row, column };
  update(id, extend ? { focus: point } : { anchor: point, focus: point });
}

export function setTableSearch(id: string, search: string) {
  update(id, { search: search.slice(0, 120) });
}

export function tableSelection(id: string): CellRange {
  const value = getTableInteraction(id);
  return {
    startRow: value.anchor.row,
    startColumn: value.anchor.column,
    endRow: value.focus.row,
    endColumn: value.focus.column,
  };
}
